<div class="mx-auto p-8 bg-white-light border-radius-5 rounded-sm">
    <div class="">
        <p-stepper [value]="step" [linear]="true">
            <!-- Step 1: Introduction -->
            <p-step-item [value]="1">
                <p-step>{{ "ai_meetings.stepper.step1.head" | translate }}</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col gap-4 items-center">
                            <img src="assets/plateformebeneficiaire/images/ai-helper.svg" alt="Assistant IA" class="h-36 mb-2" />
                            <h2 class="text-2xl font-bold text-center">
                                {{ "ai_meetings.stepper.step1.title" | translate }}
                            </h2>
                            <p class="text-gray-700 text-center max-w-xl">
                                {{ "ai_meetings.stepper.step1.description" | translate }}
                            </p>
                        </div>
                        <div class="flex justify-end mt-4">
                            <p-button label="Commencer" (onClick)="nextStep()" severity="primary"></p-button>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <!-- Step 2: Motif de la demande -->
            <p-step-item [value]="2">
                <p-step>{{ "ai_meetings.stepper.step2.head" | translate }}</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <ng-container *ngIf="!promptAnalysisLoading(); else loadingPanel">
                            <div class="flex flex-col gap-4">
                                <h2 class="text-xl font-bold">{{ "ai_meetings.stepper.step2.title" | translate }}</h2>
                                <p class="text-gray-600">{{ "ai_meetings.stepper.step2.description" | translate }}</p>
                                <textarea pTextarea [(ngModel)]="motif" rows="4" class="w-full border rounded p-2" placeholder="Décrivez votre demande..."></textarea>
                            </div>
                            <div class="flex justify-end mt-4">
                                <p-button label="Suivant" [disabled]="!motif" (onClick)="nextStep()" severity="contrast"></p-button>
                            </div>
                        </ng-container>
                        <ng-template #loadingPanel>
                            <div class="flex flex-col items-center justify-center min-h-[250px]">
                                <div class="innovative-loader mb-6">
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                </div>
                                <div class="text-lg font-semibold text-blue-700 animate-pulse">{{ "ai_meetings.stepper.step2.loading" | translate }}</div>
                            </div>
                        </ng-template>
                    </ng-template>
                </p-step-panel>
            </p-step-item>


            <!-- Step 3: Analyse du motif de la demande -->
            <p-step-item [value]="3">
                <p-step>{{ "ai_meetings.stepper.step3.head" | translate }}</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <ng-container *ngIf="!documentsLoading(); else documentsLoadingPanel">
                            <div class="flex flex-col gap-4">
                                <h4 class="text-lg font-bold">{{ "ai_meetings.stepper.step3.title" | translate }}</h4>
                                <p-message *ngIf="promptAnalysisOutsideScope()" severity="error">
                                    <u>{{ "ai_meetings.stepper.step3.outside_scope" | translate }}</u><br/>
                                    <ul class="ml-4 mt-4 list-disc">
                                        <li>{{promptAnalysisOutsideScopeMessage()}}</li>
                                        <li>{{ "ai_meetings.stepper.step3.outside_scope_fallback" | translate }}</li>
                                    </ul>
                                </p-message>

                                <div *ngIf="!promptAnalysisOutsideScope()" class="flex-column ml-4">
                                    <p-message severity="info">
                                        {{ "ai_meetings.stepper.step3.in_scope" | translate }}
                                        <a href="#" class="text-blue-600 text-underline underline hover:text-blue-800" (click)="previousStep(); $event.preventDefault();">
                                        Modifier ma demande
                                        </a>
                                    </p-message>
                                    <p-button
                                        *ngFor="let label of promptAnalysisThemes()"
                                        [label]="label"
                                        [severity]="selected.includes(label) ? 'success' : 'secondary'"
                                        [icon]="selected.includes(label) ? 'pi pi-check' : ''"
                                        variant="outlined"
                                        iconPos="left"
                                        class="flex mb-2 ml-4"
                                        (click)="toggleSelection(label)">
                                    </p-button>
                                </div>
                            </div>
                            <div class="flex justify-end mt-4">
                                <p-button
                                    severity="info"
                                    class="text-white rounded-lg mx-auto sm:mx-3"
                                    *ngIf="promptAnalysisOutsideScope()"
                                    (click)="previousStep()">
                                    Modifier ma demande
                                </p-button>
                                <p-button
                                    label="Suivant"
                                    [disabled]="
                                        promptAnalysisOutsideScope() ||
                                        selected.length == 0
                                    "
                                    (onClick)="nextStep()"
                                    severity="contrast">
                                </p-button>
                            </div>
                        </ng-container>
                        <ng-template #documentsLoadingPanel>
                            <div class="flex flex-col items-center justify-center min-h-[250px]">
                                <div class="innovative-loader mb-6">
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                </div>
                                <div class="text-lg font-semibold text-blue-700 animate-pulse">Recherche des documents nécessaires...</div>
                            </div>
                        </ng-template>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <!-- Step 4: Upload des documents -->
            <p-step-item [value]="4">
                <p-step>{{ "ai_meetings.stepper.step4.head" | translate }}</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <ng-container *ngIf="!articlesLoading(); else articlesLoadingPanel">
                            <div class="flex flex-col gap-4">
                                <h4 class="text-xl font-bold">{{ "ai_meetings.stepper.step4.title" | translate }}</h4>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div *ngFor="let doc of documents" class="doc-card border-2 border-dashed border-gray-400 rounded-lg p-4 bg-white flex flex-col items-center relative shadow-sm">
                                        <span class="font-semibold text-gray-700 mb-2">{{ doc }}</span>
                                        <div class="w-full flex flex-col gap-2">
                                            <div *ngFor="let file of uploads[doc]; let i = index" class="flex items-center gap-2 mb-2">
                                                <input type="file" class="hidden" [id]="'file-'+doc+'-'+i" (change)="onFileSelected($event, doc, i)" />
                                                <label [for]="'file-'+doc+'-'+i" class="flex-1 cursor-pointer dragdrop-area border-2 border-dashed border-gray-300 rounded-lg p-2 text-center transition hover:border-gray-500 bg-gray-50">
                                                    <span *ngIf="!uploads[doc][i]">Glissez-déposez ou cliquez pour ajouter un fichier</span>
                                                    <span *ngIf="uploads[doc][i]">{{ uploads[doc][i].name }}</span>
                                                </label>
                                                <button type="button" class="text-red-500 hover:text-red-700" (click)="removeFileField(doc, i)" *ngIf="uploads[doc].length > 1">
                                                    <i class="pi pi-times"></i>
                                                </button>
                                            </div>
                                            <button type="button" class="text-gray-600 text-sm flex items-center gap-1 hover:underline mt-1" (click)="addFileField(doc)">
                                                <i class="pi pi-plus-circle"></i> Déposer un autre fichier
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-end mt-4">
                                <p-button label="Suivant" (onClick)="nextStep()"
                                    severity="contrast"></p-button>
                            </div>

                        </ng-container>
                        <ng-template #articlesLoadingPanel>
                            <div class="flex flex-col items-center justify-center min-h-[250px]">
                                <div class="innovative-loader mb-6">
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                    <div class="loader-bubble"></div>
                                </div>
                                <div class="text-lg font-semibold text-blue-700 animate-pulse">Recherche des articles cohérents...</div>
                            </div>
                        </ng-template>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <!-- Step 5: Ressources utiles -->
            <p-step-item [value]="5">
                <p-step>{{ "ai_meetings.stepper.step5.head" | translate }}</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col gap-4">
                            <h2 class="text-xl font-bold">
                                {{ "ai_meetings.stepper.step5.title" | translate }}
                            </h2>
                            <p class="text-gray-600">
                                <u>{{ "ai_meetings.stepper.step5.description" | translate }}</u>
                            </p>
                            <div class="grid grid-cols-12 gap-4 grid-nogutter bg-transparent">
                                @for (article of articles; track article.id) {
                                  <div
                                    class="col-span-12 sm:col-span-6 lg:col-span-4 p-2 article-card-container"
                                  >
                                    <app-news-card [news]="article" [showMotsCles]="true"/>
                                  </div>
                                }
                            </div>
                        </div>
                        <div class="flex justify-end mt-4">
                            <p-button label="J'ai consulté les ressources" (onClick)="nextStep()"
                                severity="primary"></p-button>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <!-- Step 6: Numéro de ticket -->
            <p-step-item [value]="6">
                <p-step>{{ "ai_meetings.stepper.step6.head" | translate }}</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col items-center gap-4">
                            <h2 class="text-2xl font-bold text-green-700">{{ "ai_meetings.stepper.step6.title" | translate }}</h2>
                            <p class="text-gray-700 text-center">
                                Conservez <span class="font-semibold">votre numéro de ticket</span> <span class="font-mono bg-green-50 px-2 py-1 rounded">{{ ticketNumber }}</span>
                                <br>et <span class="font-semibold">votre code PIN</span> <span class="font-mono bg-green-50 px-2 py-1 rounded">: {{ ticketPin }}</span><br>
                                ils vous seront demandés lors de votre rendez-vous pour retrouver vos documents.<br>
                                <span class="text-sm text-gray-500">En cas d'oubli, ils restent disponibles dans la page <b>Mes rendez-vous</b>.</span>
                            </p>
                            <div class="flex flex-col gap-2 items-center mt-2">
                                <div class="bg-green-100 text-green-800 rounded px-6 py-4 text-2xl font-mono tracking-widest shadow">
                                    {{ ticketNumber }}
                                </div>
                                <div class="bg-green-200 text-green-900 rounded px-6 py-2 text-xl font-mono tracking-widest shadow">
                                    {{ ticketPin }}
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
        </p-stepper>
    </div>

</div>
